module.exports = __webpack_public_path__ + "img/lachssushirollenohnehintergrund.2626979d.png";